import $ from "jquery";
import "@fancyapps/ui";
import Swal from "sweetalert2";
// import "./firebase";
import { info } from "../libs/init";
import * as Bootstrap from "bootstrap";
import { createApp } from "vue";
import InstallApp from "@/components/install-app.vue";

const config = info();

declare var window;
declare var main;

window.Swal = Swal;
window.$ = $;
window.jQuery = $;
window.config = config;
window.bootstrap = Bootstrap;

window.addEventListener("load", function () {
  if (typeof main === "function") {
    main();
  }
  createApp(InstallApp).mount("#install-app");
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${config.url.base.relative}/service-worker-${config.env}.js`, {
        scope: `${config.url.base.relative === "/" ? "/" : `${config.url.base.relative}/`}`,
      })
      .then((registration) => {
        console.log("SW registered");
        if (config.env !== "prod") {
          console.log("Registration : ", registration);
        }
        // import("./sw");
      })
      .catch((registrationError) => {
        console.log("SW registration failed: ", registrationError);
      });
  });
}
